
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wiki/languages",
      function () {
        return require("private-next-pages/wiki/languages/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wiki/languages"])
      });
    }
  